/**
 * Labels vertical-aware del booking (#285 A). Wellness usa "clase"/"instructor";
 * Boutique usa "servicio"/"quién te atiende" — mismo motor, distinto copy. i18n-lite:
 * un mapa por vertical, NO hardcode disperso. La vertical se deriva del tipo de
 * offering (SLOT = Boutique, CLASS = Wellness) o del módulo del tenant.
 */
export type BookingVertical = 'wellness' | 'boutique';

export interface BookingLabels {
  /** Opción "todas" del filtro de oferta. */
  allOfferings: string;
  /** Opción "todos" del filtro de quién atiende. */
  allProviders: string;
  /** Etiqueta del filtro de quién atiende. */
  providerFilterLabel: string;
  /** Cómo se nombra a quién da el servicio (para labels del editor). */
  providerLabel: string;
  /** Plural para la pantalla de administración de la lista (botón/título). */
  providerPlural: string;
  /** Prefijo en la tarjeta: Wellness = el nombre pelón; Boutique = "te atiende X". */
  withProvider: (name: string) => string;
  offeringSingular: string;
  offeringPlural: string;
}

const WELLNESS: BookingLabels = {
  allOfferings: 'Todas las clases',
  allProviders: 'Todos los instructores',
  providerFilterLabel: 'Instructor/a',
  providerLabel: 'Instructor/a',
  providerPlural: 'Instructores',
  withProvider: (n) => n,
  offeringSingular: 'clase',
  offeringPlural: 'clases',
};

const BOUTIQUE: BookingLabels = {
  allOfferings: 'Todos los servicios',
  allProviders: 'Todos',
  providerFilterLabel: 'Quién te atiende',
  providerLabel: 'Quién atiende',
  providerPlural: 'Personal',
  withProvider: (n) => `te atiende ${n}`,
  offeringSingular: 'servicio',
  offeringPlural: 'servicios',
};

export function bookingLabels(v: BookingVertical): BookingLabels {
  return v === 'boutique' ? BOUTIQUE : WELLNESS;
}

/** Deriva la vertical de una lista de offerings/slots por su `offeringKind`:
 *  todo SLOT (y al menos uno) = Boutique; cualquier CLASS (o vacío) = Wellness. */
export function verticalFromKinds(kinds: Array<string | null | undefined>): BookingVertical {
  const known = kinds.filter(Boolean);
  return known.length > 0 && known.every((k) => k === 'SLOT') ? 'boutique' : 'wellness';
}

/** Vertical desde un `kind` único (editor admin). */
export function verticalOfKind(kind?: string | null): BookingVertical {
  return kind === 'SLOT' ? 'boutique' : 'wellness';
}
